import PostFeed from './PostsFeed';
import PostFeedContainer from './PostsFeed.container';
export default PostFeedContainer(PostFeed);
